export default __webpack_public_path__ + "static/media/grafema_angura_11.934e08f5.jpg";